module.exports = __webpack_public_path__ + "static/media/srilanka-white.340e5118.svg";